import { registerBlock } from "./registry";

registerBlock({
  type: "paragraph",
  title: "Paragraph",
  icon: "¶",
  defaultContent: ""
});
